import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { CompanionRule, Deleteparam } from '../companion-rule.model';

export enum CompanionRuleActionTypes {
  GetCompanionRuleList = '[Companion] Get Companion Rule List',
  GetCompanionRuleListFail = '[Companion] Get Companion Rule List Fail',
  UpsertCompanionRuleList = '[Companion] Upsert Companion Rule List',
  NoCompanionRuleList = '[Companion] No Companion Rule List',
  UpdateCompanionRule = '[Companion] Update Companion Rule',
  UpdateCompanionRuleFail = '[Companion] Update Companion Rule Fail',
}

export class GetCompanionRuleList implements Action {
  readonly type = CompanionRuleActionTypes.GetCompanionRuleList;

  constructor(public payload: any = null) {}
}

export class GetCompanionRuleListFail implements Action {
  readonly type = CompanionRuleActionTypes.GetCompanionRuleListFail;
}

export class UpsertCompanionRuleList implements Action {
  readonly type = CompanionRuleActionTypes.UpsertCompanionRuleList;

  constructor(public payload: any = null) {}
}

export class NoCompanionRuleList implements Action {
  readonly type = CompanionRuleActionTypes.NoCompanionRuleList;
}

export class UpdateCompanionRule implements Action {
  readonly type = CompanionRuleActionTypes.UpdateCompanionRule;

  constructor(public payload: any = null) {}
}

export class UpdateCompanionRuleFail implements Action {
  readonly type = CompanionRuleActionTypes.UpdateCompanionRuleFail;
}

export type CompanionRuleActions =
 GetCompanionRuleList
 | GetCompanionRuleListFail
 | UpsertCompanionRuleList
 | NoCompanionRuleList
 | UpdateCompanionRule
 | UpdateCompanionRuleFail;
